"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isArray_1 = __importDefault(require("lodash/isArray"));
const ToastContext_1 = require("context/ToastContext");
const FirebaseUtils_1 = require("utils/FirebaseUtils");
const HelperUtils_1 = require("utils/HelperUtils");
const useNetworkError = () => {
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const pushError = (error) => {
        const message = error?.message;
        const title = error?.title;
        if ((0, isArray_1.default)(message)) {
            message?.map((mes) => {
                mes?.errors?.map((msg) => {
                    addToast({
                        title: (0, HelperUtils_1.getObjectiveLocale)(title || 'Failed'),
                        msg: msg,
                        type: 'error',
                        dataCy: 'warning-toast'
                    });
                });
            });
        }
        else {
            addToast({
                title: (0, HelperUtils_1.getObjectiveLocale)(title || 'Failed'),
                msg: message,
                type: 'error',
                dataCy: 'warning-toast'
            });
        }
    };
    const showErrorToast = (endpoint, err) => {
        if (!endpoint?.includes('auth') &&
            !endpoint?.includes('password') &&
            !endpoint?.includes('send_activation') &&
            !endpoint?.includes('integrations')) {
            switch (err?.code) {
                case 401:
                    if (!window.Cypress && !localStorage.getItem('tokenInvalid')) {
                        'Notification' in window &&
                            Notification.permission !== 'denied' &&
                            (0, FirebaseUtils_1.unSubcribeFirebase)();
                        localStorage.setItem('tokenInvalid', true.toString());
                        alert(err.message);
                        location.replace('/login/email');
                    }
                    break;
                case 422:
                    err.message =
                        err?.message?.length > 200
                            ? 'Something went wrong on our side! Please try again later'
                            : err?.message;
                    pushError(err);
                    break;
                case 403:
                    pushError({
                        message: err?.message || 'Not Allowed',
                        code: 403
                    });
                    break;
                case 404:
                case 429:
                    pushError(err);
                    break;
                case 500:
                    pushError({
                        message: 'Something went wrong on our side! Please try again later',
                        code: 500
                    });
                    break;
                default:
                    break;
            }
        }
    };
    const globalHandler = (error) => {
        const endpoint = error?.config?.url;
        const err = error?.response?.data?.error
            ? error?.response?.data?.error
            : error?.response?.data?.errors;
        const resultError = {
            ...error,
            showErrorToast: () => showErrorToast(endpoint, err)
        };
        return Promise.reject(resultError);
    };
    return { pushError, globalHandler };
};
exports.default = useNetworkError;
